// extracted by mini-css-extract-plugin
export var grid = "grid-module--grid--PNyF6";
export var grid__wrapper = "grid-module--grid__wrapper--3VpdQ";
export var grid__itemIcon = "grid-module--grid__item-icon--KFmhu";
export var grid__itemTitle = "grid-module--grid__item-title--gN+zp";
export var grid__itemDesc = "grid-module--grid__item-desc--zpFEV";